<app-organizer-shared-layout-edit-field
  [title]="'organizer.edit.description.title' | translate"
  [description]="'organizer.edit.description.description' | translate"
  [isFormValid]="isFormValid"
  [isFormDirty]="description.dirty"
  [hasInitialValue]="hasInitialValue"
  [isOverlayDisplayed]="isOverlayDisplayed"
  [overlayStatus]="overlayStatus"
  (submitted)="updateDescription()"
>
  <app-form-input-group
    [label]="'organizer.edit.description.content.title' | translate"
    [tips]="'organizer.edit.description.content.label' | translate"
    [errors]="description?.touched && description?.errors"
    errorKey="description"
  >
    <app-form-textarea
      #content
      [formControl]="description"
      [placeholder]="'organizer.edit.description.placeholder' | translate"
      [rows]="5"
      [minLength]="minimumCharacters"
    ></app-form-textarea>
  </app-form-input-group>

  <app-tips
    #rightColumn
    right-column
    [title]="'organizer.edit.description.tips.title' | translate"
    [tips]="'organizer.edit.description.tips.text' | translate"
    [variant]="variantTips"
    [displayArrowIcon]="false"
  ></app-tips>
</app-organizer-shared-layout-edit-field>
